import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { ScriptEditorPane } from "@/components/scripts/script-editor-pane";
import type { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/scripts/$scriptId",
)({
  component: ScriptDetailPage,
});

function ScriptDetailPage() {
  const { scriptId } = Route.useParams();
  const id = scriptId === "new" ? null : (scriptId as Id<"scripts">);

  return (
    <RouteGuardPermissions
      permissions={[{ module: "custom_fields", actions: ["read", "update"] }]}
    >
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <ScriptEditorPane scriptId={id} />
      </div>
    </RouteGuardPermissions>
  );
}
